import { List } from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { ProjectDriveFolderItems } from 'records/ProjectDriveFolderItems';
import { ProjectDriveSelectedItem } from 'records/ProjectDriveSelectedItem';
import {
  getProjectDriveFolderItems,
  getProjectDriveItems,
  getProjectDrives,
} from 'services/projectDriveService';

export interface ProjectDriveActions {
  getProjectDrives: (actionParams: AppStateActionParams) => Promise<AppState>;
  getProjectDriveFolderItems: (
    actionParams: AppStateActionParams,
    driveId: string,
    folderId?: string
  ) => Promise<AppState>;
  setProjectDriveSelectedItems: (
    actionParams: AppStateActionParams,
    selectedItems: List<ProjectDriveSelectedItem>
  ) => AppState;
  resetProjectDriveSelection: (actionParams: AppStateActionParams) => AppState;
}

const ProjectDriveActions: ProjectDriveActions = {
  getProjectDrives: async ({
    state,
  }: AppStateActionParams): Promise<AppState> => {
    const { selectedProject } = state();
    const projectDrives = await getProjectDrives(selectedProject);

    return state().set('projectDrives', projectDrives);
  },

  getProjectDriveFolderItems: async (
    { state }: AppStateActionParams,
    driveId: string,
    folderId?: string
  ): Promise<AppState> => {
    const { selectedProject } = state();

    if (folderId) {
      const projectDriveFolderItems = await getProjectDriveFolderItems(
        selectedProject,
        driveId,
        folderId
      );

      return state().set('projectDriveCurrentItems', projectDriveFolderItems);
    }

    const projectDriveItems = await getProjectDriveItems(
      selectedProject,
      driveId
    );

    return state().set('projectDriveCurrentItems', projectDriveItems);
  },

  setProjectDriveSelectedItems: (
    { state }: AppStateActionParams,
    selectedItems: List<ProjectDriveSelectedItem>
  ): AppState => {
    return state().set('projectDriveSelectedItems', selectedItems);
  },

  resetProjectDriveSelection: ({ state }: AppStateActionParams): AppState => {
    return state()
      .set('projectDriveCurrentItems', new ProjectDriveFolderItems())
      .set('projectDriveSelectedItems', List<ProjectDriveSelectedItem>());
  },
};

export default ProjectDriveActions;
